// extracted by mini-css-extract-plugin
export var createdDate = "_hj-1";
export var divider = "_hj-2";
export var headerDivider = "_hj-3";
export var messagesCard = "_hj-0";
export var messagesContainer = "_hj-6";
export var messagesContainerWrapper = "_hj-4";
export var showLeftPanelButton = "_hj-8";
export var topButtons = "_hj-7";
export var withPadding = "_hj-5";